import React, { useContext } from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Image from '../shared/Image';
import preview from '../../public/image/preview.png'
import './Tags.css';
import { priceFormat } from '../../util/showPriceFormat';
import config from './../../config.json';
import { useNavigate } from 'react-router-dom';
import MainContext from '../../context/mainContext';


const Tags = ({ group }) => {

    const navigate = useNavigate();
    const context = useContext(MainContext)

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 1199, min: 992 },
            items: 5
        },
        tablet: {
            breakpoint: { max: 991, min: 576 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 575, min: 0 },
            items: 2.5,
            slidesToSlide: 3
        }
    };


    return (
        <div className='group-layer'>
            <h6>
                <span></span>
                {group.name}
            </h6>
            <div style={{ height: '210px', width: '100%' }} className=' rtl mx-auto d-none d-sm-block'>
                <Carousel
                    customTransition={(window.innerWidth >= 576) ? 'transform 0.5s ease-in-out' : 'transform 0.15s ease-in-out'}
                    className='h-100'
                    rtl={true}
                    swipeable={true}
                    draggable={false}
                    keyBoardControl={true}
                    showDots={false}
                    responsive={responsive}
                    infinite={(window.innerWidth >= 576) ? true : false}
                    autoPlay={(window.innerWidth >= 576) ? true : false}
                    autoPlaySpeed={3000}
                    // centerMode={true}
                    transitionDuration={500}
                    // focusOnSelect={true}
                    // containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                // deviceType={this.props.deviceType}
                // dotListClass="custom-dot-list-style"
                // itemClass="mx-2"
                >
                    {
                        group.products.map(product =>
                            <div className='group-item' style={{ cursor: 'default' }} key={product._id}
                                onClick={() => navigate(`/products/${product._id}`, { state: { ...product }, preventScrollReset: true })}
                            >
                                <div className='pt-2'>

                                    <Image
                                        src={product.image ? `${config.api_address}/upload/${product.image}` : preview}
                                        // onClick={() => setShowTargetImage(product.image)}
                                        width={90}
                                        height={90}
                                        style={{
                                            objectFit: 'cover', opacity: product.image ? '1' : '.5',
                                            borderRadius: '10px', marginLeft: 'auto', marginRight: 'auto'
                                        }}
                                        borderRadius={'10px'}
                                    />
                                    <div className='title'>{product.name}</div>
                                    <div className='text-success' style={{ fontSize: '.9rem' }}>
                                        {
                                            (context.loggedIn && context.loggedIn.status === 'Enable') ?
                                                <div >
                                                    <div className='text-danger' style={{ height: '17px' }}>
                                                        {
                                                            product.fakePrice ?
                                                                <>
                                                                    <span style={{ fontSize: ".8rem" }}>{`${priceFormat(String(product.fakePrice))} `}</span>
                                                                    <div className='fake-price-line-in-tag'></div>
                                                                </> : null
                                                        }
                                                    </div>
                                                    <div className='text-success'>
                                                        <i className='fa fa-shopping-cart me-1'></i>
                                                        <span>{`${priceFormat(String(product.price))} ریال `}</span>
                                                    </div>
                                                </div>
                                                :
                                                <span>
                                                    <i className='fa fa-shopping-cart me-1'></i>
                                                    <span>سفارش</span>
                                                </span>

                                        }
                                    </div>
                                </div>
                            </div>


                        )
                    }
                </Carousel>
            </div>
            <div style={{ height: '210px', width: '100%' }}
                className=' small-group-items d-sm-none'
            >

                {
                    group.products.map(product =>
                        <div className='group-item' style={{ cursor: 'default' }} key={product._id}
                            onClick={() => navigate(`/products/${product._id}`, { state: { ...product }, preventScrollReset: true })}
                        >
                            <div className='pt-2'>
                                <Image
                                    src={product.image ? `${config.api_address}/upload/${product.image}` : preview}
                                    // onClick={() => setShowTargetImage(product.image)}
                                    width={90}
                                    height={90}
                                    style={{
                                        objectFit: 'cover', opacity: product.image ? '1' : '.5',
                                        borderRadius: '10px', marginLeft: 'auto', marginRight: 'auto'
                                    }}
                                    borderRadius={'10px'}
                                />
                                <div className='title'>{product.name}</div>
                                <div style={{ fontSize: '.9rem' }}>
                                    {
                                        (context.loggedIn && context.loggedIn.status === 'Enable') ?
                                            <div >
                                                <div className='text-danger' style={{ height: '17px' }}>
                                                    {
                                                        product.fakePrice ?
                                                            <>
                                                                <span style={{ fontSize: ".8rem" }}>{`${priceFormat(String(product.fakePrice))} `}</span>
                                                                <div className='fake-price-line-in-tag'></div>
                                                            </> : null
                                                    }
                                                </div>
                                                <div className='text-success'>
                                                    <i className='fa fa-shopping-cart me-1'></i>
                                                    <span>{`${priceFormat(String(product.price))} ریال `}</span>
                                                </div>
                                            </div>
                                            :
                                            <span>
                                                <i className='fa fa-shopping-cart me-1'></i>
                                                <span>سفارش</span>
                                            </span>

                                    }
                                    {/* </button> */}
                                </div>
                            </div>
                        </div>


                    )
                }
            </div>
        </div>
    );
}

export default Tags;